import React, { Component, Fragment } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal, Input, Tooltip, Checkbox } from 'hljd'
import { passwordRegExp, isExperienceStore } from '@util'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import store from './store'

const FormItem = Form.Item

@Form.create({
  onValuesChange: store.formValsChange
})
@observer
export default class extends Component {
  componentDidMount() {
    store.form = this.props.form
  }
  checkConfirm = (rule, value, callback) => {
    const form = this.props.form
    if (value && store.confirmDirty) {
      form.validateFields(['confirm'], { force: true })
    }
    callback(passwordRegExp(value))
  }

  checkPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && value !== form.getFieldValue('password')) {
      callback('请保持两次输入的密码一致！')
    } else {
      callback()
    }
  }

  handleConfirmBlur = e => {
    const value = e.target.value
    store.confirmDirty = store.confirmDirty || !!value
  }
  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      }
    }
    const { getFieldDecorator } = this.props.form
    const {
      params: { password, phone, nick, role_ids, confirm, id },
      isAddModalShow,
      is_edit
    } = store
    const disabled = isExperienceStore()

    return isAddModalShow ? (
      <Modal
        title={id ? '编辑子账号' : '新建子账号'}
        visible={isAddModalShow}
        onOk={store.handleOk}
        onCancel={() => store.addServiceModal()}
        okText={id ? '确认编辑' : '确认创建'}
        width={540}
      >
        <Form>
          <FormItem {...formItemLayout} label="员工姓名">
            {getFieldDecorator('nick', {
              initialValue: nick,
              rules: [
                {
                  pattern: /^[a-zA-Z0-9\u4e00-\u9fa5_@]+$/,
                  message: '支持汉字、数字、字母、符号，不能包含特殊字符'
                },
                {
                  required: true,
                  message: '请填写员工姓名！'
                }
              ]
            })(
              <Input
                style={{ width: 350 }}
                placeholder="请输入账号备注，用于称呼和身份识别"
                maxLength={20}
                disabled={disabled}
              />
            )}
          </FormItem>
          {!is_edit && (
            <Fragment>
              <FormItem {...formItemLayout} label="登录密码">
                {getFieldDecorator('password', {
                  initialValue: password,
                  rules: [
                    {
                      required: true,
                      message: '请填写登录密码！'
                    },
                    {
                      validator: this.checkConfirm
                    }
                  ]
                })(
                  <Input
                    style={{ width: 350 }}
                    type="password"
                    placeholder="请输入8-20位登录密码，需同时包含字母和数字"
                    autoComplete={'new-password'}
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label="确认密码">
                {getFieldDecorator('confirm', {
                  initialValue: confirm,
                  rules: [
                    {
                      required: true,
                      message: '请填写确认密码！'
                    },
                    {
                      validator: this.checkPassword
                    }
                  ]
                })(
                  <Input
                    style={{ width: 350 }}
                    type="password"
                    onBlur={this.handleConfirmBlur}
                    placeholder="请再次输入密码进行确认"
                  />
                )}
              </FormItem>
            </Fragment>
          )}
          <FormItem {...formItemLayout} label="拥有的权限">
            {getFieldDecorator('role_ids', {
              initialValue: toJS(role_ids),
              rules: [
                {
                  required: true,
                  message: '请选择权限！'
                }
              ]
            })(
              <Checkbox.Group>
                <Checkbox value="1">
                  <Tooltip title="客服仅具有私信、订单、评价、动态、预约等员工必要的权限">
                    客服
                  </Tooltip>
                </Checkbox>
                <Checkbox value="2">
                  <Tooltip title="门市仅拥有登录水镜·门店展示系统的权限">
                    门市
                  </Tooltip>
                </Checkbox>
                <Checkbox value="3">
                  <Tooltip title="开单拥有登录水镜·门店收单系统和门店展示系统的权限">
                    开单
                  </Tooltip>
                </Checkbox>
                <Checkbox value="4">
                  <Tooltip title="仅拥有“魔镜”权限的员工账号可以登录“魔镜·AI修片选片系统”，不能登录商家端。">
                    魔镜
                  </Tooltip>
                </Checkbox>
              </Checkbox.Group>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="账户绑定手机"
            style={{ marginBottom: 0 }}
          >
            {getFieldDecorator('phone', {
              initialValue: phone,
              rules: [
                {
                  required: true,
                  message: '请填写账户绑定手机'
                },
                {
                  pattern: /^1\d{10}$/,
                  message: '请填写11位手机号码'
                }
              ]
            })(
              <Input
                style={{ width: 350 }}
                placeholder="请输入手机号"
                disabled={disabled}
              />
            )}
          </FormItem>
          <FormItem>
            <p style={{ color: '#999', paddingLeft: 130 }}>
              请输入子账号使用的手机号，子账号首次登陆时需验证
            </p>
          </FormItem>
        </Form>
      </Modal>
    ) : null
  }
}
